import { sumTripLegPriceEstimateInCents } from './sumTripLegPriceEstimateInCents';
import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';
import { useFormValues } from 'src/common/useFormValues';
import type { AddTripFormValues } from 'src/features/add-trip/FormValues';

export function useTripFormPriceEstimateResult(): string {
  const { trips } = useFormValues<AddTripFormValues>();
  const total = sumTripLegPriceEstimateInCents(trips);
  return defaultCurrencyFormat(total.toString());
}
